import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { SvgHelper } from "@app/shared";

@Component({
  selector: "[shadow-type-5]",
  templateUrl: "./shadow-type-5.component.html",
  styleUrl: "./shadow-type-5.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShadowType5Component {
  height = input<number>();

  shadowPoints = [178, 387, 204, 290, 224, 224, 360, 309, 218, 383, 178, 387];
  multiplier = 0.27;

  shadowPath = computed(() => {
    const delta = SvgHelper.calculateDelta(this.height(), this.multiplier);
    return SvgHelper.generateType3ShadowPath(delta, this.shadowPoints);
  });
}
